import AbstractService from '@/services/abstractService'

class ProjectStatusService extends AbstractService {
  endpoint = 'projectStatuses'

  index() {
    return this.http.get(this.endpoint)
  }

  put(data) {
    console.log('data', data)
    // define append form
    const formData = new FormData()

    for (const key in data) {
      formData.append(key, data[key])
    }
    return this.http.put(`${this.endpoint}/${data.id}`, formData)
  }
}

const Service = new ProjectStatusService()

export default Service
